export default "__VITE_ASSET__$xVSM38B__"